import { AppDispatch } from "@Reducers/index";
import { getUrlForImage } from "../cubeComponent/constants/globalFunctions";
import axiosWrapper from "../services/axiosWrapper";
import { setUserDetails, toUserDetails } from "../reducers/userDetailsSlice";
import { setCheckIfAuthenticated } from "../reducers/authentication";
import { clearCsrfToken } from "@Services/axiosShared";

const saveUserDetails = setUserDetails;

export function getUserDetails() {
  return (dispatch: AppDispatch) => {
    // deliberately floating thunk: nothing dispatches this and then reads a result, and a rejected
    // request must stay unhandled so the global handler still reports it.
    void axiosWrapper.api.get("/accounts/getUserDetails").then((response) => {
      // `getUserDetailsResponse` now declares the one-element `result` array on both arms, so this
      // is a plain narrow-then-index — no cast, and a future rename of the key is a compile error
      // here rather than a silently-undefined read. (It used to be a `data?: UserDetails[]` cast
      // bolted onto an opaque `statusResponse`.)
      const row = response.data.status ? response.data.result[0] : null;
      if (row) {
        const res = toUserDetails(row);
        let data = {
          ...res,
          lastName: res.lastName ? res.lastName : "",
          profilePicUrl: res.profilePic ? getUrlForImage({ id: res._id }) : "",
          signatureUrl: res.signature
            ? axiosWrapper.api.url("/fileSystemServer/getSignDocs/:signDocId", {
                pathParams: { signDocId: res.signature },
                params: { v: Date.now() },
              })
            : "",
          messageFooterContent: res.messageFooter ?? "",
          status: true,
        };
        // Injected by the desktop shell's preload script; absent in the browser, hence the
        // optional calls. Named at the read rather than declared globally.
        (
          window as Window & { electronAPI?: { setUserDataInDesktop?: (d: unknown) => void } }
        ).electronAPI?.setUserDataInDesktop?.(data);
        dispatch(saveUserDetails(data));
      } else {
        dispatch(saveUserDetails({ status: false }));
      }
    });
  };
}

export function getCheckIfAuthenticated() {
  return (dispatch: AppDispatch) => {
    // deliberately floating thunk: the result is delivered through the store, not to the dispatcher, and a rejected
    // request must stay unhandled so the global handler still reports it.
    void axiosWrapper.api
      .get("/accounts/checkIfAuthenticated", {
        withCredentials: true,
      })
      .then((response) => {
        clearCsrfToken();
        dispatch(setCheckIfAuthenticated({ data: response.data }));
        return response.data;
      });
  };
}
